import * as React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { AiVariationContext, HideModalCallback } from '../../aiVariationTypes'
import { useManageAiVariationsTokenModal } from './useManageAiVariationsTokenModal'
import { useClipboard } from '../../../../../../../hooks/useClipboard'

import './ManageAiVariationsTokenModal.scss'

const ManageAiVariationsModal: React.FunctionComponent<AiVariationContext & HideModalCallback> = (props) => {
	const { approvalUrl, changeApprovalUrl } = useManageAiVariationsTokenModal(props)

	const {
		onCopy: onCopyApiUrlClipboard,
		value: apiUrlClipboard,
		setValue: setApiUrlClipboard,
		hasCopied: hasCopiedApiUrlClipboard,
	} = useClipboard('')

	const handleCopyApiUrl = () => {
		if (approvalUrl) {
			setApiUrlClipboard(approvalUrl)
		}
	}

	React.useEffect(() => {
		if (apiUrlClipboard) {
			onCopyApiUrlClipboard()
		}
	}, [apiUrlClipboard])

	return (
		<Modal className="ManageAiVariationsTokenModal" onHide={props.hideModal} show={true} bsSize="small">
			<Modal.Header>External approval link</Modal.Header>
			<Modal.Body>
				Allow others to approve, disapprove, edit and comment unapproved variations by sending them this link:
				<div className="approvalUrl">{approvalUrl}</div>
				<div className="changeApprovalUrlButtonContainer">
					<Button onClick={handleCopyApiUrl} className="copyApprovalUrlButton">
						{!hasCopiedApiUrlClipboard ? 'Copy link' : 'Copied!'}
					</Button>
					<Button className="changeApprovalUrlButton" onClick={changeApprovalUrl}>
						Reset link
					</Button>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button bsStyle="primary" onClick={() => props.hideModal()}>
					Ok
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default ManageAiVariationsModal
